import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './mandantenverwaltung-technik.reducer';

export const getModuleState = createFeatureSelector<ModuleState>('MandantenverwaltungTechnikPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getAzureAdConfig = createSelector(getPageState, (state: PageState) => state.azureAdConfig);
export const getSMTPConfig = createSelector(getPageState, (state: PageState) => state.smtpConfig);
export const getTroubleTicketConfig = createSelector(getPageState, (state: PageState) => state.troubleTicketConfig);
